import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";
import AllRoute from "./Route/AllRoute";




function App() {
  return (
    <>



      <Navbar />

      <AllRoute />


   <Footer/>








    </>
  );
}

export default App;
